import React from "react";

import VboardStates from "../data/VboardStates.js";

//Input: 
//array of a board state of user results as an array [1,2,0,3,4...0,1] 
//the task Id of the corresponding task 
//testEnd will output error if accessed directly wihtout taking the test first.
  
function ScoreFunction (goldImage1, predictedImage1){
	
	
	//gold recieved as a string
	const goldImageAsArray=
		goldImage1.split('').map
		(function(item) {
			return (parseInt(item, 10));
		})
	//remove the first element from predicted and gold images (indicating if the board is numbered or not numbered)
	const goldImage=goldImageAsArray.slice(1,)
	const predictedImage=predictedImage1.slice(1,)
	
	//prepare user and original task for processings
	//201 and 201 are used here as auxiliary values. 
	const goldConvertZero = goldImage.map((a, i) => a==0? 210 : a);
	const predictedConvertZero = predictedImage.map((a, i) => a==0? 201 : a);
	
	//find identical colored tiles
	const difference = goldConvertZero.map((a, i) => a - predictedConvertZero[i])
	const Identical= difference.filter (element =>element==0 ).length
	
	//find Precision and Recall denominator
	const predictedNonzero = predictedImage.filter (element =>element>0).length
	const goldNoneZero = goldImage.filter (element =>element>0 ).length
	
	
	//score
	const Precision=Identical/predictedNonzero
	const Recall=Identical/goldNoneZero
	const F1=2*Precision*Recall/(Precision+Recall)
	const score= Math.round (F1*100)
	
	//variable score does not handle extreme cases: 
	//predicted=blankboard and/or image=blankboard or recall=precision=0
	const result=()=>{
    	const predictedImageSum=predictedImage.reduce((partialSum, a) => partialSum + a, 0)
    	const goldImageSum=goldImage.reduce((partialSum, a) => partialSum + a, 0)
    	
    	//if (predictedImageSum==0) {return ('Blank Drawing')}
    	if (predictedImageSum==0) {return (0)}
    	else if (goldImageSum==0) {return ('Blank Image')}
    	else if (Precision*Recall==0) {return (0)}
    	else {return (score)}	
	}
	return (result())
	//return (Precision*Recall==0? 0 :(isNaN(score)? "Blank Image/Drawing": score) ) //[score," a ",Recall," a ",Precision," a ",Identical, " a ",difference]

}	

export default ScoreFunction;


